module.exports = __webpack_public_path__ + "a7094452eb23d64c00edc2f812e9b1b4.pdf";